import React, {useEffect, useState} from 'react';
import {isMobile} from 'react-device-detect';
import FastCall from '../../Assets/SVG/FastCall';
import CallQuality from '../../Assets/SVG/CallQuality';
import BatteryLife from '../../Assets/SVG/BatteryLife';
import AdvancedServices from '../../Assets/SVG/AdvancedServices';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';

const StartStage = (props) => {
  return <></>;
};

export default StartStage;
